var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',{attrs:{"src":_vm.safeSrc,"alt":_vm.safeAlt,"position":_vm.position,"width":_vm.width,"height":_vm.height,"max-width":_vm.maxWidth,"max-height":_vm.maxHeight,"aspect-ratio":_vm.aspectRatio,"contain":_vm.contain},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }